import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { User, Mail, Phone, MapPin } from "lucide-react";

const HOST = {
  proprietor: "Shruthi Vellore",
  email: "mrinmaya.vacationhome@gmail.com",
  phone: "+916364900718",
  phoneDisplay: "+91 63649 00718",
  address: "349, 5th Cross, C T Bed, Banashankari 2nd Stage, Bangalore - 560070",
};

export default function HostInfoPage() {
  React.useEffect(() => {
    document.title = "Host Information | Mrinmaya vacation home";
  }, []);

  return (
    <LegalLayout
      eyebrow="The host"
      title="Host Information"
      testId="host-info-page"
    >
      <p>
        Mrinmaya vacation home is independently owned and run. Below are the
        host details for booking, communication and any official correspondence.
      </p>

      <div
        className="mt-10 rounded-2xl bg-white/70 border border-mrn-sand-dark/40 divide-y divide-mrn-sand-dark/30 overflow-hidden"
        data-testid="host-info-card"
      >
        <Row
          icon={User}
          label="Proprietor"
          value={HOST.proprietor}
          testId="host-proprietor"
        />
        <Row
          icon={MapPin}
          label="Registered address"
          value={HOST.address}
          testId="host-address"
        />
        <Row
          icon={Mail}
          label="Email"
          value={
            <a
              href={`mailto:${HOST.email}`}
              className="text-mrn-terracotta link-underline break-all"
            >
              {HOST.email}
            </a>
          }
          testId="host-email"
        />
        <Row
          icon={Phone}
          label="Phone / WhatsApp"
          value={
            <a
              href={`tel:${HOST.phone}`}
              className="text-mrn-terracotta link-underline"
            >
              {HOST.phoneDisplay}
            </a>
          }
          testId="host-phone"
        />
      </div>

      <p className="mt-10 text-sm text-mrn-wood-soft">
        For any concerns related to your stay, booking, or this website, please
        feel free to reach out using any of the channels above. We typically
        respond within a few hours during waking hours (IST).
      </p>
    </LegalLayout>
  );
}

function Row({ icon: Icon, label, value, testId }) {
  return (
    <div className="flex items-start gap-4 p-5 md:p-6" data-testid={testId}>
      <div className="shrink-0 mt-0.5 rounded-full bg-mrn-terracotta/15 text-mrn-terracotta p-2">
        <Icon size={18} strokeWidth={1.8} />
      </div>
      <div className="min-w-0">
        <div className="text-xs uppercase tracking-[0.25em] text-mrn-wood-soft font-medium">
          {label}
        </div>
        <div className="mt-1 text-mrn-wood text-base md:text-lg break-words">
          {value}
        </div>
      </div>
    </div>
  );
}
